module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.11444/img/solutions-partner-icon.svg"